<span>{{tag.name}}</span><a *ngIf="removeButton" (click)="remove.emit()" data-test-qa="removeTag">&times;</a>